export async function deleteMail(emailId) {
    const response = await fetch(`https://html-creator.demo.cartago.com/api/delete-email/${emailId}`, {method:'DELETE'});
    const result = await response.json();
    console.log(result.message);
  }
  